import * as enums from '../../common/utils/enums';

export const BANDWIDTH_UNITS = [
  enums.BandwidthUnits.KILO_BITS_PER_SECOND,
  enums.BandwidthUnits.MEGA_BITS_PER_SECOND,
  enums.BandwidthUnits.GIGA_BITS_PER_SECOND,
  enums.BandwidthUnits.TERA_BITS_PER_SECOND,
];

export const BANDWIDTH_BPS_CONVERSION_VALUES = [
  enums.BandwidthInBps.KILO_BITS_PER_SECOND,
  enums.BandwidthInBps.MEGA_BITS_PER_SECOND,
  enums.BandwidthInBps.GIGA_BITS_PER_SECOND,
  enums.BandwidthInBps.TERA_BITS_PER_SECOND,
];

export const FILE_TYPE_XLSX = '.xlsx';
export const SHIPMENT_STATUS_DISPATCHED = 'dispatched';
